import Card from "@material-ui/core/Card"
import React from "react"

const About: React.SFC = (props) => {
    const cowsay = `
      .--------.
      | Pouet! |
      \`--------'
        \\
         \\   ^__^
          \\  (oo)\\_______
             (__)\\        )\\/\\
                  ||----w |
                  ||     ||

  `
    return <Card {...props}><pre>{cowsay}</pre></Card >
}

export default About
